import { CustomLocalStorage } from '@/lib/storage/customLocalStorage';

const SINGLE_RACE_KEY = 'singlerace-bet-panel-data';
const MULTIRACE_RANDOM_KEY = 'multirace-random-bet-panel-data';
const MULTIRACE_SELECT_KEY = 'multirace-select-bet-panel-data';

export enum RaceType {
  Singlerace = 'singlerace', // 7掛式
  MultiraceRandom = 'multiraceRandom', // 重勝ランダム式
  MultiraceSelect = 'multiraceSelect', // 重勝選択式
}

export const betDataLocalStorage = <T>(raceType: RaceType) => {
  let key = '';
  switch (raceType) {
    case RaceType.Singlerace:
      key = SINGLE_RACE_KEY;
      break;
    case RaceType.MultiraceRandom:
      key = MULTIRACE_RANDOM_KEY;
      break;
    case RaceType.MultiraceSelect:
      key = MULTIRACE_SELECT_KEY;
      break;
    default:
      break;
  }
  return CustomLocalStorage<T>(key);
};
